export default "__VITE_ASSET__CQ5B49b9__"